import { InjectionToken } from '@angular/core';
import { WebsocketConnectionParam } from '../model/websocket-connection-param';

export const SESSION_STORAGE_TOKEN = new InjectionToken<string>('session-storage-token');
export const WEBSOCKET_CONFIG_TOKEN = new InjectionToken<WebsocketConnectionParam>('ws-config-properties-token');

